<template>
  <div class="card">
    <div class="card-header">
      <h5>Rooming Report</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Booking Date Range</h6>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="From Date"
                id="booking-start-date"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="report.bookingStartDate.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
              />
              <small class="text-danger" v-if="reportError.booking_start_date">{{ reportError.booking_start_date }}</small>
            </div>
            <div class="col-md-6">
              <dateTimePicker
                  no-label
                  label="To Date"
                  id="booking-end-date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  v-model="report.bookingEndDate.date"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  style="border: 1px solid #DFE5F9"
                  :min-date="report.bookingStartDate.date"
                />
                <small class="text-danger" v-if="reportError.booking_end_date">{{ reportError.booking_end_date }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Arrival Date Range</h6>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="From Date"
                id="booking-start-date"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="report.arrivalStartDate.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
              />
              <small class="text-danger" v-if="reportError.arrival_start_date">{{ reportError.arrival_start_date }}</small>
            </div>
            <div class="col-md-6">
              <dateTimePicker
                  no-label
                  label="To Date"
                  id="booking-end-date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  v-model="report.arrivalEndDate.date"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  style="border: 1px solid #DFE5F9"
                  :min-date="report.arrivalStartDate.date"
                />
                <small class="text-danger" v-if="reportError.arrival_end_date">{{ reportError.arrival_end_date }}</small>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-4">
          <label for="product" class="form-label">Product</label>
            <v-select
              :options="product"
              label="name"
              class="m-0"
              id="product"
              index="id"
              v-model="report.tourType"
            />
        </div>
        <div class="col-md-4">
          <label for="resort" class="form-label">Resort</label>
            <v-select
              :options="resorts"
              label="resort_name"
              class="m-0"
              id="resort"
              index="id"
              v-model="report.resortId"
              @change="getAccommodation"
            />
        </div>
        <div class="col-md-4">
          <label for="supplier" class="form-label">Supplier</label>
            <v-select
              :options="suppliers"
              label="supplier_name"
              class="m-0"
              id="supplier"
              index="id"
              v-model="report.supplierId"
              @change="getAccommodation"
            />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4">
          <label for="accommodation" class="form-label">Accommodation Name</label>
            <v-select
              :options="accommodation"
              label="accommodation_name"
              class="m-0"
              id="accommodation"
              index="id"
              v-model="report.accommodationId"
              multiple
            />
        </div>
        <div class="col-md-4">
          <label for="checkbox" class="form-label">Include Cancelled Booking</label>
          <br>
          <label class="switch">
              <input v-model="report.includeCancelled" id="checkbox" type="checkbox"/>
              <span class="switch__slider"></span>
          </label>
        </div>
        <div class="col-md-4">
          <label for="checkbox" class="form-label">Include Pending Booking</label>
          <br>
          <label class="switch">
              <input v-model="report.includePending" id="checkbox" type="checkbox"/>
              <span class="switch__slider"></span>
          </label>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <label class="form-check-label text-center" for="orderByAccommodationName">
              Order By Accommodation Name
          </label>
          <br>
          <input v-model="report.orderBy" type="radio" style="height:1.4rem;" value="accommodation" name="orderBy" id="orderByAccommodationName">
        </div>
        <div class="col-md-4">
          <label class="form-check-label text-center" for="orderByDate">
              Order By Booking Date
          </label>
          <br>
          <input v-model="report.orderBy" type="radio" style="height:1.4rem;" value="date" name="orderBy" id="orderByDate">
        </div>
        <div class="col-md-4">
          <label class="form-check-label text-center" for="orderByDate">
              Order By Arrival Date
          </label>
          <br>
          <input v-model="report.orderBy" type="radio" style="height:1.4rem;" value="arrival_date" name="orderBy" id="orderByDate">
        </div>
      </div>
    </div>
    <div class="card-footer align-items-right">
      <button type="submit" class="button" @click="createRoomingReport">Generate Report</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomingReportFields',
  mounted() {
    this.getAccommodation();
    this.getTourType();
    this.getSuppliersAndResorts();
  },
  data() {
    return {
      accommodation: [],
      product: [],
      suppliers: [],
      resorts: [],
      report: {
        bookingStartDate: {},
        bookingEndDate: {},
        arrivalStartDate: {},
        arrivalEndDate: {},
        accommodationId: null,
        tourType: null,
        includeCancelled : false,
        includePending : false,
        orderBy : null,
        resortId : null,
        supplierId : null,
      },
      reportError:{
        booking_start_date:null,
        booking_end_date:null,
        arrival_start_date:null,
        arrival_end_date:null,
      }
    }
  },
  methods: {
    createRoomingReport() {
      this.validateFields()
        .then((response) => {
          if (response) {
            const request = {
              booking_start_date : this.report.bookingStartDate.date,
              booking_end_date : this.report.bookingEndDate.date,
              arrival_start_date : this.report.arrivalStartDate.date,
              arrival_end_date : this.report.arrivalEndDate.date,
              accommodation_id : this.report.accommodationId,
              tour_type : this.report.tourType,
              include_cancelled : this.report.includeCancelled,
              include_pending : this.report.includePending,
              order_by : this.report.orderBy,
              resort_id : this.report.resortId,
              supplier_id : this.report.supplierId,
            }
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'reports/rooming', {
              method: 'POST',
              body: JSON.stringify(request),
              headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
              }
            })
            .then((res) => {
              if(res.status === 200) {
                this.$store.dispatch('setLoadStatus')
                res.blob().then(response => {
                  const _url = window.URL.createObjectURL(response)
                  const link = document.createElement('a')
                  link.href = _url
                  link.setAttribute('download', 'rooming-report.xlsx')
                  document.body.appendChild(link)
                  link.click();
                })
              } else {
                this.$store.dispatch('setLoadStatus')
                Promise.race([res.json()])
                .then(response => {
                  if(response.message) {
                    this.$notify({
                      type: 'error',
                      title: response.message
                    });
                  } else {
                    this.$notify({
                      type: 'error',
                      title: response.error
                    });
                  }
                })
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },
    getAccommodation() {
      this.report.accommodationId = null;
      const postRequest = {
        resort_id : this.report.resortId,
        supplier_id : this.report.supplierId,
      }
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'reports/rooming/accommodation-list', {
        method: 'POST',
        body: JSON.stringify(postRequest),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.accommodation = response.data;
      })
    },
    getTourType() {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/tour-type', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.product = response.data;
      })
    },
    getSuppliersAndResorts() {
      this.$store.dispatch('setLoadStatus')
      fetch( this.$api + 'accommodation/supplier-and-resorts', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.suppliers = response.data.suppliers;
        this.resorts = response.data.resorts;
      })
    },
    validateFields(){
      let This = this
      return new Promise((resolve, reject) => {

        let errorCount = 0;

        // Booking Dates validation
        if(This.report.bookingStartDate.date && !This.report.bookingEndDate.date) {
          This.reportError.booking_end_date = "Please select booking to date"
          errorCount +=1
        }else if(This.report.bookingEndDate.date && !This.report.bookingStartDate.date){
          This.reportError.booking_start_date = "Please select booking from date"
          errorCount +=1
        }else{
          This.reportError.booking_end_date = null
          This.reportError.booking_start_date = null
        }

        // Arrival Dates validation 
        if(This.report.arrivalStartDate.date && !This.report.arrivalEndDate.date) {
          This.reportError.arrival_end_date = "Please select arrival to date"
          errorCount +=1
        }else if(This.report.arrivalEndDate.date && !This.report.arrivalStartDate.date){
          This.reportError.arrival_start_date = "Please select arrival from date"
          errorCount +=1
        }else{
          This.reportError.arrival_end_date = null
          This.reportError.arrival_start_date = null
        }
        
        // Check for Arrival date and Booking date
        if ( !This.report.bookingStartDate.date && !This.report.arrivalStartDate.date) 
        {
          This.reportError.booking_start_date = "Please select booking date or arrival date"
          This.reportError.arrival_start_date = "Please select arrival date or booking date"

          errorCount +=1
        }else{
          This.reportError.booking_start_date = null
          This.reportError.arrival_start_date = null
        }


        if(errorCount == 0 ){
          resolve(true)
        }else{
          reject(true)
        }

      })
    }
  }
}
</script>
